module.exports = __webpack_public_path__ + "6.9a357217.png";